// extracted by mini-css-extract-plugin
export default {"message":"OHELtFf","MktLangSelect":"jQI_TJ0"};